import React, {Component, Fragment} from 'react';
import {withRouter} from 'react-router-dom';
import works from "../../consumers/works";
import articles from "../../consumers/articles";
import PostHeader from "../components/post/PostHeader";
import PostSections from "../components/post/PostSections";

class SinglePost extends Component {

    constructor(props) {
        super(props);
        this.state = {
            title: "",
            photo: "",
            sections: []
        };
        this.handleArticle = this.handleArticle.bind(this);
    }

    componentDidMount() {
        const reference = this.props.reference;
        if (reference) {
            const {id} = this.props.match.params;
            reference.child(id).orderByChild('position').once('value').then(this.handleArticle);
        }
    }

    handleArticle(snapshot) {
        const title = snapshot.child('title').val();
        const photo = snapshot.child('photo').val();
        const sections = [];
        snapshot.forEach(function (childSnapshot) {
            const key = childSnapshot.key;
            if (key !== 'title' && key !== 'photo' && key !== 'key') {
                const section = childSnapshot.val();
                sections.push(section);
            }
        });
        this.setState({
            title: title,
            photo: photo,
            sections: sections
        });
    }

    render() {
        return (
            <Fragment>
                <PostHeader title={this.state.title} photo={this.state.photo}/>
                <PostSections sections={this.state.sections}/>
            </Fragment>
        );
    }
}

const singlePost = withRouter(SinglePost);

export const SingleWork = works(singlePost);
export const SingleArticle = articles(singlePost);


// WEBPACK FOOTER //
// ./src/visitors/subscribers/SinglePost.js